export default __webpack_public_path__ + "static/prince-b90ca2eef60a43d0788dc2604d6831f0.png";